import React from 'react';
import { FormattedMessage } from '@99designs/frontend-components/i18n';

const LocalTime = ({ utcOffset }: { utcOffset: string }) => {
    if (!utcOffset) {
        return null;
    }

    // Get current UTC time
    const now = new Date();
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;

    // Adjust time with UTC offset e.g. "+1000", "-0700"
    const utcOffsetMilliseconds = parseFloat(utcOffset) * 36000;
    const localDate = new Date(utc + utcOffsetMilliseconds);

    // typecast to any as the type definition does not include hourCycle
    // https://github.com/microsoft/TypeScript/issues/34399
    const time = localDate.toLocaleTimeString('default', {
        hour: 'numeric',
        minute: 'numeric',
        hourCycle: 'h12', // 12 hour clock, with midnight starting at 12:00 am
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any);

    return (
        <div>
            <FormattedMessage message={__(`Local time: {time}`)} values={{ time }} />
        </div>
    );
};

export default LocalTime;
